import React, { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Link } from '@node-space/ui-components'
import { ExternalLinks } from 'constants/links'
import { EmbeddedUseCase, UIConfig } from '../helpers/types'
import { FullScreenLayout } from './FullScreenLayout'
import { InfoHeader } from './InfoHeader'
import { PublicPageLayout } from './PublicPageLayout'

export interface PageWrapperProps extends PropsWithChildren {
  showHeaderAndFooter: boolean
  useCase?: EmbeddedUseCase
  isUsEntity: boolean
  uiConfig: UIConfig
  Header?: ReactNode
  Footer?: ReactNode
}

const PageFooter = ({ isUsEntity, uiConfig }: { isUsEntity: boolean; uiConfig: UIConfig }) => {
  const { t } = useTranslation()
  const footerShared = t('customerPendingAgreements.footer')
  const licenseHelpUrl = ExternalLinks.LICENSES_HELP_URL ?? ''

  if (isUsEntity) {
    return (
      <>
        {`${footerShared} ${t('customerPendingAgreements.footerAdditionUs')} `}
        {licenseHelpUrl && (
          <span
            {...(uiConfig?.primaryColor && {
              style: { color: `#${uiConfig?.primaryColor}` },
            })}
          >
            <Link
              href={licenseHelpUrl}
              target="_blank"
              {...(uiConfig?.primaryColor && { className: 'text-inherit' })}
            >
              {t('customerPendingAgreements.footerLinkUs')}
            </Link>
          </span>
        )}
      </>
    )
  }

  return footerShared
}

export const PageWrapper = ({
  showHeaderAndFooter,
  isUsEntity,
  useCase,
  uiConfig,
  children,
  Footer,
}: PageWrapperProps) => {
  return uiConfig?.isBranded ? (
    <PublicPageLayout
      {...(showHeaderAndFooter && {
        header: <InfoHeader useCase={useCase} />,
        footer: Footer ?? <PageFooter isUsEntity={isUsEntity} uiConfig={uiConfig} />,
      })}
    >
      {children}
    </PublicPageLayout>
  ) : (
    <FullScreenLayout {...(uiConfig?.isDarkMode && { className: `bg-[#232323]` })}>
      <Box flexCol width="full" gap={24} padding={32} className="md:px-[60px] md:pb-12 md:pt-10">
        {children}
      </Box>
    </FullScreenLayout>
  )
}
